import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthenticationService } from '../../services/auth/authentication.service';
import { AlertifyService } from '../../services/alertify/alertify.service';

export const permissionsGuard: CanActivateFn = (route) => {
  const authenticationService = inject(AuthenticationService);
  const alertifyService = inject(AlertifyService);
  const router = inject(Router);

  const requiredPermissions = route.data['permissions'] as string[];
  if (!requiredPermissions || requiredPermissions.length === 0) {
    return true;
  }
  if (authenticationService.hasAnyPermission(requiredPermissions)) {
    return true;
  }

  alertifyService.error('User does not have the required permission(s)');
  return router.parseUrl(router.url);
};
